import { render, staticRenderFns } from "./mypromocode.vue?vue&type=template&id=84098872&scoped=true&"
import script from "./mypromocode.vue?vue&type=script&lang=js&"
export * from "./mypromocode.vue?vue&type=script&lang=js&"
import style0 from "./mypromocode.vue?vue&type=style&index=0&id=84098872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84098872",
  null
  
)

export default component.exports